import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env?.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env?.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables. Please check your .env file for VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
  }
});

// Defer logging to avoid blocking module initialization during build
if (typeof window !== 'undefined') {
  // Run verification logs after DOM is ready
  setTimeout(() => {
    console.log('=== SUPABASE PROJECT VERIFICATION ===');
    console.log('SUPABASE_URL:', supabaseUrl);
    console.log('Expected URL:', 'https://bzvrhammnttdsvfpyfnb.supabase.co');
    console.log('URL Match:', supabaseUrl === 'https://bzvrhammnttdsvfpyfnb.supabase.co' ? '✅ CORRECT' : '❌ MISMATCH');
    console.log('SUPABASE_ANON_KEY (first 20 chars):', supabaseAnonKey?.substring(0, 20) + '...');
    console.log('Supabase client initialized with URL:', supabase?.supabaseUrl);
    console.log('=====================================\n');
  }, 0);

  // Expose Supabase client in DevTools for debugging (development only)
  if (import.meta.env?.DEV) {
    window.supabase = supabase;
    console.log('🔧 [DEV MODE] Supabase client exposed as window.supabase for DevTools debugging');
  }
}
